<template>
  <div>
    <input
      :id="id"
      :name="name"
      :value="value"
      type="hidden">
    <trix-editor
      :input="id"
      :placeholder="placeholder"/>
  </div>
</template>

<style lang="scss">
trix-editor {
  background-color: white;
}
.trix-mini {
  &.input {
    border-radius: 5px;
  }
  trix-toolbar {
    display: none;
  }
  trix-editor {
    margin-top: 0;
    min-height: 0;
  }
}
.border-0 {
  trix-editor {
    border: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
  }
}
</style>

<script>
import 'trix'
import $ from 'jquery'
import Vue from 'vue'

Vue.config.ignoredElements = ['trix-editor']

let trixEditorIdPool = 0

export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      input: null,
      id: 'trix' + ++trixEditorIdPool
    }
  },
  watch: {
    value () {
      if (this.value !== this.input.value) {
        $(this.$el).find('trix-editor')[0].editor.loadHTML(this.value)
      }
    }
  },
  mounted () {
    let el = document.querySelector(`[input="${this.id}"]`)
    this.input = document.getElementById(this.id)

    el.addEventListener('trix-change', () => {
      this.$emit('input', this.input.value)
    })
  }
}
</script>
